(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (global = global || self, factory(global.h5utils = {}));
}(this, function (exports) { 'use strict';

  function isMobileSafari() {
    var ua = navigator.userAgent;
    var isIos = / OS \d/.test(ua);
    var notChrome = !~ua.indexOf('CriOS');
    var notMozilla = !ua.indexOf('Mozilla');
    var isSafari = /Safari\/[\d\.]+$/.test(ua);
    return isIos && notChrome && notMozilla && isSafari;
  }

  var getBrowserVersion = function getBrowserVersion() {
    var ua = navigator.userAgent;
    return {
      baiduspider: /Baiduspider/.test(ua),
      QQLive: /QQLive/i.test(ua),
      mqq: /QQ\/([\d\.]+)/i.test(ua), //是否为手机QQ
      weibo: /Weibo/i.test(ua), //是否为微博
      MicroMessenger: /MicroMessenger/i.test(ua), //是否为微信
      mbaidu: /baiduboxapp/i.test(ua), //是否为手机百度
      iqiyi: /iqiyi/i.test(ua),
      qq: /MQQBrowser/i.test(ua), //是否为QQ浏览器
      mobile: /AppleWebKit.*Mobile.*/i.test(ua), //是否为移动终端
      uc: /UCBrowser/i.test(ua), //是否为UC
      xiaomiqjs: /MiuiQuickSearchBox/.test(ua),
      dianping: /dianping/.test(ua),
      ios: /\(i[^;]+;( U;)? CPU.+Mac OS X/i.test(ua), //ios终端
      android: /Android/i.test(ua) || /Linux/i.test(ua), //android终端或者uc浏览器
      windowsphone: /Windows Phone/i.test(ua), //Windows Phone
      iPhone: /iPhone/i.test(ua), //是否为iPhone或者QQHD浏览器
      iPad: /iPad/i.test(ua), //是否iPad
      webApp: !/Safari/i.test(ua), //是否web应该程序，没有头部与底部
      baidu: /Baidu/i.test(ua), //是否为百度浏览器
      Safari: isMobileSafari(),
      Youku: /youku/i.test(ua),
      chrome: /CriOS/i.test(ua),
      CMDC: /CMDC/i.test(ua),
      BiliApp: /BiliApp/i.test(ua)
    };
  };

  var customReport = function customReport(name, ops) {
    if (window.reportConfig && window[reportConfig['msgObjects']]) {
      var reportObj = window[reportConfig['msgObjects']];
      var obj = ops ? ops : name;
      reportObj[name] = obj;
    }
    if (window.reportObserver) {
      window.reportObserver.forceCommit();
    }
  };

  var ajax = function ajax(url, callback) {
    var req = new XMLHttpRequest();
    req.onreadystatechange = function (e) {
      if (this.readyState === 4 && this.status === 200) {
        var data = JSON.parse(this.response);
        callback(data);
      }
    };
    req.onerror = function () {};
    req.ontimeout = function () {};
    req.open("GET", url);
    req.send();
  };

  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

  function getDownloadLink(schema, directDownload, delayDownload, extra, wxDownloadKey) {
    var browser = getBrowserVersion();
    if (browser.MicroMessenger) {
      var keyMap = {
        share_source_weixinchat: 'CK1463338442777',
        share_source_weixin_moments: 'CK1463338350392',
        share_source_more: 'CK1463338994314',
        share_source_copy_link: 'CK1474482145968',
        wechat: 'CK1385399615180'
      };
      if ((typeof wxDownloadKey === 'undefined' ? 'undefined' : _typeof(wxDownloadKey)) === 'object') {
        for (var i in wxDownloadKey) {
          keyMap[i] = wxDownloadKey[i];
        }
      }
      var ckey = keyMap[window.bsource] || 'CK1389719810898';

      if (window.bsource === 'app_bili') {
        return '//a.app.qq.com/o/simple.jsp?pkgname=tv.danmaku.bili&ckey=' + ckey;
      } else if (browser.android) {
        var downloadLink = '//a.app.qq.com/o/simple.jsp?pkgname=tv.danmaku.bili&ckey=' + ckey;
        var realSchema = schema.indexOf('?') > 0 ? schema + '&' + extra : schema + '?' + extra;
        return downloadLink + '&android_schema=' + encodeURIComponent(realSchema);
      } else {
        return '//a.app.qq.com/o/simple.jsp?pkgname=tv.danmaku.bili&ckey=' + ckey;
      }
    }

    if (browser.android) {
      var href = '//dl.hdslb.com/mobile/latest/iBiliPlayer-bilih5.apk';
      if (window.isOverSea) {
        href = 'https://dl.hdslb.com/mobile/upload/iBiliPlayer-internation-default.apk';
      }
      // 微博源
      if (browser.weibo || window.WeiboJSBridge || window.WebViewJavascriptBridge || window.__WeiboJSBridge) {
        href = 'https://dl.hdslb.com/mobile/latest/iBiliPlayer-html5_weibo.apk';
      }
      // 百度源
      if (browser.baidu || window.bd_searchbox_interface || window.bdbox_android_common) {
        href = 'https://dl.hdslb.com/mobile/latest/iBiliPlayer-html5_bdbox.apk';
      }
      // uc源
      if ((browser.uc || window.ucbrowser || window.ucapi) && document.referrer && document.referrer.indexOf('tv.uc.cn') >= 0) {
        href = 'https://dl.hdslb.com/mobile/latest/iBiliPlayer-html5_uc_video.apk';
      }
      if (window.bsource) {
        href = 'https://dl.hdslb.com/mobile/latest/iBiliPlayer-html5_' + window.bsource + '.apk';
      }
      if (!directDownload && !delayDownload) {
        href = 'http://d.bilibili.com/download_app.html?download_url=' + encodeURIComponent(href) + '&schema=' + encodeURIComponent(schema);
      }
      return href;
    }

    if (browser.ios) {
      var _href = 'https://itunes.apple.com/cn/app/bi-li-bi-li-dong-hua/id736536022';
      if (browser.weibo || browser.chrome) {
        _href = 'https://itunes.apple.com/cn/app/id736536022?mt=8#id1047562725';
      }
      if (!directDownload) {
        return 'http://d.bilibili.com/download_app.html?download_url=' + encodeURIComponent(_href) + '&schema=' + encodeURIComponent(schema);
      }
      return _href;
    }

    if (browser.windowsphone) {
      return 'https://www.windowsphone.com/zh-cn/store/purchase/validate?app=75620dee-4a7a-4dae-8677-0d930e05f57e&apptype=regular&offer=3869edb1-e34c-469a-af6e-2c8a7856cb61';
    }
  }

  function openAppLink(redirectLink, downloadLink, autoDownload, delayDownload) {
    if (!redirectLink || !downloadLink) {
      return;
    }
    if (delayDownload) {
      if (autoDownload) {
        setTimeout(function () {
          if (!document.hidden) {
            location.href = downloadLink;
          }
        }, 2000);
      }
      location.href = redirectLink;
    } else {
      if (autoDownload) {
        setTimeout(function () {
          location.href = downloadLink;
        }, 500);
      }
      location.href = redirectLink;
    }
  }

  var openApp = function openApp(options) {
    options = options || {};
    var _options = options,
        schema = _options.schema,
        universalLink = _options.universalLink,
        autoDownload = _options.autoDownload,
        onlySchema = _options.onlySchema,
        directDownload = _options.directDownload,
        delayDownload = _options.delayDownload,
        downloadUrl = _options.downloadUrl,
        extra = _options.extra,
        wxDownloadKey = _options.wxDownloadKey;

    if (typeof autoDownload === 'undefined') {
      autoDownload = true;
    }
    extra = extra || '';
    schema = schema || 'bilibili://rank';
    universalLink = universalLink || 'http://m.bilibili.com/index.html';
    var browser = getBrowserVersion();
    if (browser.BiliApp) {
      location.href = schema;
      return;
    }
    var downloadLink = downloadUrl || getDownloadLink(schema, directDownload, delayDownload, extra, wxDownloadKey);
    if (downloadLink.indexOf('.apk') > 0 || downloadLink.indexOf('d.bilibili.com') > 0 || downloadLink.indexOf('app.qq.com') > 0) {
      customReport('request_download', 1);
    }

    if (browser.android && browser.MicroMessenger) {
      location.href = downloadLink;
      return;
    }

    var needJumpMiddlePage = browser.weibo || browser.qq || browser.wechat || window.bsource === 'xxqg1';
    if ((browser.ios || needJumpMiddlePage) && !onlySchema && !directDownload) {
      location.href = 'http://d.bilibili.com/download_app.html?preUrl=' + encodeURIComponent(universalLink) + '&schema=' + encodeURIComponent(schema) + '&' + extra;
      return;
    }

    var realSchema = schema.indexOf('?') > 0 ? schema + '&' + extra : schema + '?' + extra;

    openAppLink(realSchema, downloadLink, autoDownload, delayDownload);
  };

  var judgeOverSea = function judgeOverSea() {
    ajax('//api.bilibili.com/x/web-interface/zone?jsonp=jsonp', function (data) {
      if (data.code === 0 && data.data && data.data.country && data.data.country !== '中国') {
        window.isOverSea = true;
      }
    });
  };

  var createOpenAppBtn = function createOpenAppBtn(options) {
    var el = options.el,
        onClick = options.onClick,
        onWxLaunch = options.onWxLaunch,
        onWxError = options.onWxError,
        schema = options.schema,
        extra = options.extra;

    if (!el instanceof HTMLElement) {
      return;
    }
    var browser = getBrowserVersion();
    if (browser.MicroMessenger) {
      var realSchema = schema.indexOf('?') > 0 ? schema + '&' + extra : schema + '?' + extra;
      var container = document.createElement('div');
      container.className = 'wx-open-app';
      container.innerHTML = '<wx-open-launch-app\n      appid="' + options.appid + '"\n      extinfo="' + realSchema + '"\n      class="wx-open-app-btn"\n    >\n      <script type="text/wxtag-template">\n        <style>\n          .template {\n            width: 100%;\n            height: 100%;\n          }\n        </style>\n        <div class="template"><br><br><br><br><br><br><br><br><br><br><br><br></div>\n      </script>\n    </wx-open-launch-app>';
      el.appendChild(container);

      var wxBtn = container.querySelector('.wx-open-app-btn');
      wxBtn.addEventListener('launch', function (e) {
        if (typeof onWxLaunch === 'function') {
          onWxLaunch(e);
        }
      });
      wxBtn.addEventListener('error', function (e) {
        if (typeof onWxError === 'function') {
          onWxError(e);
        }
        openApp(options);
      });
      return;
    }
    el.addEventListener('click', function (e) {
      if (typeof onClick === 'function') {
        onClick(e);
      }
      openApp(options);
    });
  };

  var init = function init() {
    var style = document.createElement('style');
    style.innerHTML = '\n    .wx-open-app, .wx-open-app-btn {\n      position: absolute;\n      left: 0;\n      right: 0;\n      top: 0;\n      bottom: 0;\n      z-index: 20;\n      overflow: hidden;\n    }\n  ';
    document.body.appendChild(style);
  };

  exports.createOpenAppBtn = createOpenAppBtn;
  exports.init = init;
  exports.judgeOverSea = judgeOverSea;
  exports.openApp = openApp;

  Object.defineProperty(exports, '__esModule', { value: true });

}));
